var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"containerplot"}},[_c('svg',{attrs:{"id":'dotplotskills' + _vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }